import React, { Component } from "react";
import { Steps } from "primereact/steps";
import $ from "jquery";
import DispatchService from "../../services/DispatchService";
import PrintSecondaryPackagingService from '../../services/PrintSecondaryPackagingService';
import MessageComponent from "../../template/Message";
export default class QrCodeReport extends Component {
  constructor(props) {
    super(props);
    this.DispatchService = new DispatchService();
    this.PrintSecondaryPackagingService = new PrintSecondaryPackagingService();
    this.state = {
      journeyList: [],
      secondaryQR: [],
      scanTxt: "",
      genQR: "",
      activeIndex: 0,
      // Personal : true,
      // Seat : false,
      // Payment : false,
      // Confirmation : false
    };
    this.items = [
      // {
      //     label: 'Personal',
      //     command: (event) => {
      //       this.setState({Personal : true, Seat: false, Payment:false, Confirmation:false})
      //     }
      // },
      // {
      //     label: 'Seat',
      //     command: (event) => {
      //       this.setState({Seat : true, Personal : false, Payment:false, Confirmation:false})
      //     }
      // },
      // {
      //     label: 'Payment',
      //     command: (event) => {
      //       this.setState({Personal : false, Seat: false, Payment:true, Confirmation:false})
      //     }
      // },
      // {
      //     label: 'Confirmation',
      //     command: (event) => {
      //       this.setState({Personal : false, Seat: false, Payment:false, Confirmation:true})
      //     }
      // }
    ];
    // $(document).ready(function(){
    //   $('#step2, #step3').hide();

    //   $("#stepBtn1").click(function(){
    //     $('#stepBtn2, #stepBtn3').removeClass('active');
    //     $('#step2, #step3').hide();
    //     $("#step1").show();
    //   });
    //   $("#stepBtn2").click(function(){
    //     $(this).addClass('active');
    //     $('#stepBtn3').removeClass('active');
    //     $('#step1, #step3').hide();
    //     $("#step2").show();
    //   });
    //   $("#stepBtn3").click(function(){
    //     $(this).addClass('active');
    //     $('#stepBtn2').addClass('active');
    //     $('#step1, #step2').hide();
    //     $("#step3").show();
    //   });

    // });

    this.ScanItem = this.ScanItem.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // call every change of form and validation part also
  handleChange(event) {
    debugger
    const { name, value } = event.target;
    let errors = this.state.formError;

    // const isValid = this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }
  // scan qr code
  ScanItem(e) {  //scan without url
    debugger
    if (e.key == 'Enter') {
      let qr = e.target.value;

      if (qr.includes("uid")) {
        debugger
        // use for local system
        //Run in local selve sy
        //const url = "http://localhost:3000/pa?uid=";
        //Use for testing
        //const url ="http://104.211.167.63:5153/pa?uid=";
        //Use For Live 
        //const url ="http://localhost:3000/pa?uid=";
        //const fObj = { UID: url+qr }

        this.DispatchService.GetJourney(qr).then((data) => {
          debugger;
          const resdata = data.data;
          //if response data not null
          if (resdata !== null && resdata.ResponseCode === "200") {

            //  this.items = [] = [];
            this.setState({
              journeyList: resdata.ResponseData
            });

          }

          else this.refs.Messchild.showWarn(resdata.ResponseMessage);
        });
      } else if (qr.includes('SID')) {
        debugger
        this.DispatchService.GetJourney(qr).then((data) => {
          debugger;
          const resdata = data.data;
          //if response data not null
          if (resdata !== null && resdata.ResponseCode === "200") {

            //  this.items = [] = [];
            this.setState({
              journeyList: resdata.ResponseData
            });

          } else this.refs.Messchild.showWarn(resdata.ResponseMessage);
        });

      } else if (qr.includes('TID')) {
        debugger
        this.DispatchService.GetJourney(qr).then((data) => {
          debugger;
          const resdata = data.data;
          //if response data not null
          if (resdata !== null && resdata.ResponseCode === "200") {

            //  this.items = [] = [];
            this.setState({
              journeyList: resdata.ResponseData
            });

          } else this.refs.Messchild.showWarn(resdata.ResponseMessage);
        });

      } else if (qr.includes('DID')) {
        debugger
        this.DispatchService.GetJourney(qr).then((data) => {
          debugger;
          const resdata = data.data;
          //if response data not null
          if (resdata !== null && resdata.ResponseCode === "200") {

            //  this.items = [] = [];
            this.setState({
              journeyList: resdata.ResponseData
            });

          } else this.refs.Messchild.showWarn(resdata.ResponseMessage);
        });
      }
      else {
        this.refs.Messchild.showWarn("Invalid QR code scanned");
      }
      this.setState({
        scanTxt: ""
      });
    }

  }
  // ScanItem(e) { //scan with url

  //   debugger

  //   if (e.key === 'Enter') {

  //     let qr = e.target.value;




  //     if (qr.includes("uid")) {

  //       this.DispatchService.GetJourney(qr).then((data) => {

  //         debugger;

  //         const resdata = data.data;

  //         //if response data not null

  //         if (resdata !== null && resdata.ResponseCode === "200") {



  //           //  this.items = [] = [];

  //           this.setState({

  //             journeyList: resdata.ResponseData

  //           });



  //         } else this.refs.Messchild.showWarn(resdata.ResponseMessage);

  //       });

  //     } else {

  //       this.refs.Messchild.showWarn("Invalid QR code scanned");

  //     }

  //     this.setState({

  //       scanTxt: ""

  //     });

  //   }




  // }


  // Method to fetch secondary QR data
  getSecondaryQR = async (e) => {
    e.preventDefault(); // Prevent form submission

    const qr = e.target.genQR.value.trim(); // Get the value from the form input

    if (qr) {
      try {
        const data = await this.DispatchService.GetSecondary(qr);

        const resp = data.data;
        // Check the response code and update state accordingly
        if (resp.ResponseCode === "200") {
          this.setState({ secondaryQR: resp.ResponseData });
          // -----------------\
          this.PrintSecondaryPackagingService.formPreview1([resp.ResponseData]);

          // -----------------
        } else {
          this.refs.Messchild.showWarn(resp.ResponseMessage); // Show warning message
        }
      } catch (error) {
        console.error("Error fetching secondary QR data:", error);
        this.refs.Messchild.showWarn("Failed to fetch data"); // Show warning message on error
      }
    } else {
      this.refs.Messchild.showWarn("Invalid QR code scanned");
    }

    // Clear input field after submission
    this.setState({ genQR: "" });
  };



  render() {
    const item = []
    debugger
    for (const [index, value] of this.state.journeyList.entries()) {
      item.push(<li className="active" key={index}>{value.activity} {value.date ? <span><i className="fa fa-clock-o"></i> {value.date}</span> : null} {value.ProductName ? <span>Product Name:<i className=""></i> {value.ProductName}</span> : null} </li>)
    }
    const itemLength = (60 * item.length) + 'px';
    itemLength.toString();
    const mystyle = {
      height: itemLength
    }
    return (
      <>
        <MessageComponent ref="Messchild" />
        <div className="heading mb-2">
          <h1>QR Code Tracking Report</h1>
        </div>

        <div className="qrcode-container d-flex flex-row flex-wrap justify-content-around">
          <div className="h100 d-flex justify-content-center align-items-center">
            <div className="h100 d-flex flex-wrap" >
              <div className="col-md-12">
                <h1>Track QR Code</h1>

                {/* <input value={this.state.scanTxt} style={{width:'400px'}} type="search" placeholder="Scan items"
          className="form-control" id="scan" onChange={(e)=> {
        this.ScanItem(e);
        }}
        /> */}
                <div className="input-section">
                  <input onChange={e => { this.handleChange(e) }} name="scanTxt" value={this.state.scanTxt} id="textInput" placeholder="Enter Qr code" onKeyDown={e => { this.ScanItem(e) }} />
                </div>
              </div>
              {/* <div className="col-md-3">
          <label>Scan SID:</label>
          <input style={{ width: '' }} onChange={e => { this.handleChange(e) }} name="scanSID" value={this.state.scanSID} type="search" className="form-control ml-2" id="scan" onKeyDown={e => { this.ScanItem(e) }} />
        </div>
        <div className="col-md-3">
          <label>Scan TID:</label>
          <input style={{ width: '' }} onChange={e => { this.handleChange(e) }} name="scanTID" value={this.state.scanTID} type="search" className="form-control ml-2" id="scan" onKeyDown={e => { this.ScanItem(e) }} />
        </div>
        <div className="col-md-3">
          <label>Scan DID:</label>
          <input style={{ width: '' }} onChange={e => { this.handleChange(e) }} name="scanDID" value={this.state.scanDID} type="search" className="form-control ml-2" id="scan" onKeyDown={e => { this.ScanItem(e) }} />
        </div> */}

              <div className="col-md-12">
                <ul className="timeline" style={mystyle}>
                  {item}
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex" style={{ borderRight: '1px dashed #f9ca9a', margin: '15px' }}>
          </div>

          <div className="h100 d-flex align-items-center">
            <div>
              <h1>Secondary QR Code Generator</h1>
              <div className="input-section">
                <form className="gap-2" onSubmit={e => { this.getSecondaryQR(e) }} >
                  <input name="genQR" id="textInput" placeholder="Enter Qr code" />
                  <button type="submit" className="qr-button">Generate</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
